<template lang="pug">
  .div
    .columns.is-vcentered
      .column.is-2
        label.label Fecha de Resolución:
        .field
          .control
            flat-pickr(
              v-model='resolucion.fechaResolucion'
              :config="config"
              class="input",
              :disabled="isDisabled"
            )
      .column.is-3
        .field
          label.label Diágnostico
            .control.has-icons-left
              .select.is-primary.is-rounded
                select(v-model="resolucion.diagnostico" :disabled="isDisabled")
                  option(v-for="res in resoluciones" :key="res.id" :value="res") {{ res.texto }}
              .icon.is-small.is-left
                i.fas.fa-fix
      .column.is-1
        .field
          label.label Restante (días)
          .control
            input.input.is-primary(
              type='number', 
              v-model="resolucion.restante",
              :disabled="isDisabled"
              min="0"
            )
      .column.is-2
        .field
          input#inpCompra.is-checkradio(type='checkbox' v-model='resolucion.compra' :disabled="isDisabled")
          label.is-size-6(for='inpCompra') Comprar
      .column.is-4
        .field
          label.label Comentarios
          .control
            textarea.textarea.is-primary(
              v-model="resolucion.comentarios",
              placeholder='....', 
              rows='2',
              :disabled="isDisabled"
            )
    .columns.is-vcentered
      .column.is-offset-2.is-8
        AttachmentGen(@changeFile="changeFile" v-show="estadoform==0 || (estadoform==2 && cambiarEvidencia)" :isDisabled="isDisabled")
        br
        a.button.is-black.is-rounded(v-show="estadoform==2 && cambiarEvidencia" @click="changeEvidencia")
          i.fas.fa-sync-alt
          | &nbsp Cancelar Cambiar Evidencia
        figure.image.is-256x256
          img(:src="getEvidencia()" v-show="estadoform == 1 || (estadoform==2 && !cambiarEvidencia)")
        br
        a.button.is-black.is-rounded(v-show="estadoform==2 && !cambiarEvidencia" @click="changeEvidencia")
          i.fas.fa-sync-alt
          | &nbsp Cambiar Evidencia
    .columns(v-show="datosFaltantes.length > 0")
      .column.is-12
        .notification
          button.delete(@click="borrarNotificacion")
          .field.is-grouped.is-grouped-multiline
            .control(v-for="datosF in datosFaltantes")
              .tags
                span.tag.is-danger.is-light {{ datosF }}
    .columns
      .column.is-offset-4.is-4(v-show="estadoform==0" @click="checkForm")
        a.button.is-black.is-rounded.is-block
          | Guardar
      .column.is-offset-4.is-4(v-show="estadoform==1" @click="editForm")
        a.button.is-warning.is-rounded.is-block
          | Editar
      .column.is-offset-2.is-4(v-show="estadoform==2" @click="checkUpdateForm")
        a.button.is-info.is-rounded.is-block
          | Actualizar
      .column.is-4(v-show="estadoform==2" @click="cancelEditForm")
        a.button.is-black.is-rounded.is-block
          | Cancelar
    .columns.column-blanco
</template>

<script>
  import flatPickr from 'vue-flatpickr-component'
  import 'flatpickr/dist/flatpickr.css'
  import { Spanish } from "flatpickr/dist/l10n/es.js"
  
  import AttachmentGen from '../shared/AttachmentGen.vue'
  import moment from 'moment'
  
  export default {
    name: 'FormResolucion',
    components: { flatPickr, AttachmentGen },
    props: {
      ticketBD: {
        type: Object,
        default: () => {}
      },
    },
    data() {
      return {
        config: {
          wrap: true, // set wrap to true only when using 'input-group'
          altFormat: 'Y-m-d',
          altInput: true,
          dateFormat: 'Y-m-d',
          locale: Spanish, // locale for this instance only
        },
        resoluciones: [
          {id: 0, texto: 'No se puede reparar.'},
          {id: 1, texto: 'Reparado'},
        ],
        resolucion: {
          fechaResolucion: moment().format('YYYY-MM-DD'),
          diagnostico: null,
          restante: 0,
          comentarios: null,
          file: null,
          compra: false
        },
        isDisabled: false,
        estadoform: 0,
        datosFaltantes: [],
        cambiarEvidencia: false
      }
    },
    
    methods: {
      iniciarComponente() {
        if (this.ticketBD.editado){
          this.estadoform = 1
          this.isDisabled = true
          this.rellenarData()
        } else {
          this.estadoform = 0
          this.isDisabled = false
        }

      },
      changeFile(file) {
        this.resolucion.file = file
      },

      checkForm() {
        this.datosFaltantes = []
        if (this.resolucion.diagnostico && this.resolucion.comentarios && this.resolucion.file) {
          this.saveForm()
        } else {
          if (!this.resolucion.diagnostico) {
            this.datosFaltantes.push('El diagnóstico es requerido')
          }
          if (!this.resolucion.comentarios) {
            this.datosFaltantes.push('Los comentarios son requeridos')
          }
          if (!this.resolucion.file) {
            this.datosFaltantes.push('La imagen es requerida')
          }
        }
      },
      saveForm() {
        let myObj = {
          comentarios: this.resolucion.comentarios,
          compra: this.resolucion.compra,
          id_diagnostico: this.resolucion.diagnostico.id,
          text_diagnostico: this.resolucion.diagnostico.texto,
          fechaResolucion: this.resolucion.fechaResolucion,
          file: this.resolucion.file,
          nameFile: this.resolucion.file.name,
          restante: parseInt(this.resolucion.restante)
        }
        this.$emit('saveForm', myObj)
      },
      editForm() {
        let myEvidencia = this.ticketBD.evidencia 
        this.ticketBD.evidencia = ''
        console.log(this.ticketBD.evidencia)
        this.ticketBD.evidencia = myEvidencia
        console.log(this.ticketBD.evidencia)
        this.estadoform = 2
        this.isDisabled = false
      },
      cancelEditForm() {
        this.estadoform = 1
        this.isDisabled = true
      },
      updateForm() {
        console.log('updateForm')
        let myObj = {
          comentarios: this.resolucion.comentarios,
          compra: this.resolucion.compra,
          id_diagnostico: this.resolucion.diagnostico.id,
          text_diagnostico: this.resolucion.diagnostico.texto,
          fechaResolucion: this.resolucion.fechaResolucion,
          file: this.resolucion.file? this.resolucion.file : '',
          nameFile: this.resolucion.file? this.resolucion.file.name : '',
          restante: parseInt(this.resolucion.restante)
        }
        this.$emit('upateForm', myObj)
      },
      checkUpdateForm() {
        if (this.cambiarEvidencia) {
          this.datosFaltantes = []
          console.log(`Cambiar evicencia: ${this.cambiarEvidencia}`)
          if (this.resolucion.diagnostico && this.resolucion.comentarios && this.resolucion.file) {
            this.updateForm()
          } else {
            if (!this.resolucion.diagnostico) {
              this.datosFaltantes.push('El diagnóstico es requerido')
            }
            if (!this.resolucion.comentarios) {
              this.datosFaltantes.push('Los comentarios son requeridos')
            }
            if (!this.resolucion.file) {
              this.datosFaltantes.push('La imagen es requerida')
            }
          }
        } else {
          this.datosFaltantes = []
          console.log(`Cambiar evicencia: ${this.cambiarEvidencia}`)
          if (this.resolucion.diagnostico && this.resolucion.comentarios) {
            this.updateForm()
          } else {
            if (!this.resolucion.diagnostico) {
              this.datosFaltantes.push('El diagnóstico es requerido')
            }
            if (!this.resolucion.comentarios) {
              this.datosFaltantes.push('Los comentarios son requeridos')
            }
          }
        }
      },
      changeEvidencia () {
        console.log('CambiarEvidencia')
        if (this.cambiarEvidencia) {
          this.cambiarEvidencia = false
        } else {
          this.cambiarEvidencia = true
        }
        
      },
      borrarNotificacion() {
        this.datosFaltantes = []
      },
      rellenarData () {
        console.log('rellenar Data')
        this.resolucion.fechaResolucion = this.ticketBD.fechaRes
        this.resolucion.diagnostico = this.resoluciones.find(resul => resul.id == this.ticketBD.diagnostico)
        this.resolucion.restante = this.ticketBD.restante
        this.resolucion.comentarios = this.ticketBD.comentarios
        if (this.ticketBD.compra == 1) {
          this.resolucion.compra = true
        } else {
          this.resolucion.compra = false
        }
        this.resolucion.evidencia = this.ticketBD.evidencia
      },
      getEvidencia() {
        let currentURL = window.location.hostname
        return `https://${currentURL}${this.ticketBD.evidencia}`
      }
    },
    created () {
      this.iniciarComponente()
    },
  }
</script>

<style lang="css" scoped>

</style>


// WEBPACK FOOTER //
// src/components/soporte_Componentes/FormResolucion.vue